import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { UpgradeModule } from '@angular/upgrade/static';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';
import * as AngularJsAppModule from '../angularJS/appjs.module';

const states = [];

@NgModule({
  declarations: [
  ],
  imports: [
    BrowserModule,
    UpgradeModule,
    UIRouterUpgradeModule.forRoot({ states: states })
  ],
  providers: [UpgradeModule],
  bootstrap: []
})
export class AppModule {
  constructor(private upgradeModule: UpgradeModule) {
  }

  public ngDoBootstrap() {
    AngularJsAppModule.initialise((<any>window).keycloakInstance);
    this.upgradeModule.bootstrap(document.body, ['app'], { strictDi: true });
  }
}
